module.exports = __webpack_public_path__ + "media/images/icon__xco--rb-light-gray@3x-23dd4321f5af3bb20d44b8290e2b41f1.png";